import { overlay } from 'overlay-kit';
import type { SearchQuizsetRes } from '@/api/gen/_model/searchQuizsetRes';
import { showCreateCollectionModal } from './showCreateCollectionModal';

/**
 * 퀴즈를 컬렉션에 담는 모달을 연다.
 *
 * 퀴즈 상세·자료실·검색 어디서든 열 수 있게 도메인에 둔다 — 저장은 특정 화면의 기능이 아니라
 * "퀴즈를 발견한 자리"의 기능이다.
 */
export async function showSaveToCollectionModal(quiz: Pick<SearchQuizsetRes, 'id' | 'isPublic'>) {
  const {
    SaveToCollectionModal
  } = await import('./components/SaveToCollectionModal');
  overlay.open(({
    unmount
  }) => <SaveToCollectionModal quiz={quiz} onClose={unmount} onCreateCollection={() => void showCreateCollectionModal()} />, {
    overlayId: 'save-to-collection-modal'
  });
}